"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var Keys = {
  ENTER: 13,
  ESCAPE: 27,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT_ARROW: 37,
  UP_ARROW: 38,
  RIGHT_ARROW: 39,
  DOWN_ARROW: 40
};
var _default = Keys;
exports["default"] = _default;